import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import ToggleTema from "../componentesEspeciales/toggleTema";

function CabeceraAdmin() {
    const navigate = useNavigate();
    const paramsUsuario = useParams(); // obtenemos params para poner en url

    function handleLogOut(event){
        // evita el parpadeo predefinido
        event.preventDefault();

        localStorage.clear(); // limpiamos el almacentaiento local.
        axios.post("/logout")
        .then(function(response){
            console.log(response);
            navigate("/");
        });
    }


    return(
        <div>
        {/* La razón de este header es porque ayuda a que el sidebar sea adaptable */}
            <header className="navbar sticky-top bg-dark flex-md-nowrap p-0 shadow" data-bs-theme="dark">
                    <div className="col-md-3 mt-2 ms-2 py-1">
                        <img src='/imagenes/marca/zervicyblancohorizontal.png' alt="" height="40px"/>
                    </div>

                <div className="ms-auto me-3 d-flex align-items-center">
                    <ToggleTema />
                </div>

                <ul className="navbar-nav flex-row d-md-none">
                    <li className="nav-item text-nowrap">
                    <button className="nav-link px-3 text-white" type="button" data-bs-toggle="offcanvas" data-bs-target="#sidebarMenu" aria-controls="sidebarMenu" aria-expanded="false" aria-label="Toggle navigation">
                    <i className="bi bi-list"></i>
                    </button>
                    </li>
                </ul>
            </header>
            



                        
        </div>
    )
}

export default CabeceraAdmin;